<template>
  <div id="admin-exam-list">
    <!-- 考试列表 -->
    <diy_table
      :loading="loading"
      :tipData="tipData"
      :active="active"
      :searchData="searchData"
      :tableState="true"
      :buttonList="buttonList"
      :tableMenu="tableMenu"
      :tableData="tableData"
      :tableButton="tableButton"
      :pageData="pageData"
      @handleClickTop="handleClickTop"
      @showActive="showActive"
      @initTable="initTable"
      @handleClick="handleClick"
    ></diy_table>

    <diy_dialog
      v-if="dialogData.flag"
      :title="dialogData.title"
      :width="dialogData.width"
      :dialogData="dialogData.dialogData"
      :buttonList="dialogData.buttonList"
      @colseDialog="colseDialog"
      @dialogOper="dialogOper"
    ></diy_dialog>
  </div>
</template>

<script>
import * as examData from "./js/exam.js";
import * as base from "../js/base.js";
export default {
  data() {
    return {
      tipData: [
        { text: "全部", key: "0" },
        { text: "待发布", key: "1" },
        { text: "已归档", key: "2" },
      ],
      loading: false,
      active: "0",
      searchData: this.$systemBaseData.getSearchData("exam"),
      buttonList: this.$systemBaseData.getTopButArray("exam"),
      tableMenu: this.$systemBaseData.getTableMenuData("exam"),
      tableData: [],
      tableButton: this.$systemBaseData.getTableButtonList("exam", "待发布"),
      pageData: {
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页条数
        total: 0, // 总条目数
      },

      tempQuestion: {},

      dialogData: {
        flag: false,
        title: "考试详情",
        width: "40%",
        tempData: {},
        dialogData: [{ type: "exam_details", value: "" }],
        buttonList: [],
      },

      allAuthorityList: [],
    };
  },
  methods: {
    // 权限设置  获取部门设置界面所有子界面的权限  考试管理 50
    async getUsersAllAuthorityByModel() {
      try {
        let resultData = await this.$request({
          url: "/authority/getUsersAllAuthorityByModel",
          method: "post",
          data: { feature: "50" },
        });
        this.buttonList = base.returnAllButton(
          this.buttonList,
          resultData,
          "name"
        );
        this.allAuthorityList = resultData;
      } catch (error) {}
    },
    /**
     * 初始化表格数据
     */
    async initTable(data) {
      this.loading = true;
      try {
        setTimeout(async () => {
          let requestData = {
            status: this.active == "0" ? "" : this.active,
            currentPage: data.pageData.currentPage,
            pageSize: data.pageData.pageSize,
          };
          requestData = this.$baseData.array2json(data.searchData, requestData);
          console.log(requestData);
          if (requestData.time == null || requestData.time.length == 0) {
            requestData.time = ["", ""];
          }
          let resultData = await this.$request({
            url: "/exam/getAllTestList",
            method: "post",
            data: requestData,
          });
          resultData.tableData.forEach((element) => {
            let buttList = this.$systemBaseData.getTableButtonList(
              "exam",
              element.status
            );
            buttList = base.returnAllButton(
              buttList,
              this.allAuthorityList,
              "text"
            );
            this.$set(element, "butList", buttList);
          });
          this.tableData = resultData.tableData;
          this.pageData.total = resultData.total;
          console.log(this.tableData);
          this.loading = false;
        }, 300);
      } catch (error) {
        this.$message.error(error.message);
        this.loading = false;
      }
    },
    /**
     * 搜索框旁边的按钮操作
     */
    handleClickTop(active) {
      switch (active) {
        case "create":
          // 新增科目
          this.$router.push({
            path: "/admin/exam-index/edit",
            query: {
              id: "",
            },
          });
          break;
        case "export_exam":
          // 考试导出
          let requestData = {
            status: this.active == "0" ? "" : this.active,
          };
          requestData = this.$baseData.array2json(this.searchData, requestData);
          if (requestData.time == null || requestData.time.length == 0) {
            requestData.time = ["", ""];
          }
          this.$requestForReport(
            "post",
            "/exam/exportExam",
            requestData,
            (data) => {
              let blob = new Blob([data], {
                type: "application/force-download",
              }); // Blob 对象表示一个不可变、原始数据的类文件对象
              console.log(blob);
              let fileReader = new FileReader(); // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
              fileReader.readAsDataURL(blob);
              //开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
              fileReader.onload = (e) => {
                let a = document.createElement("a");
                a.download = `考试列表.xls`;
                a.href = e.target.result;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
              };

              this.$message({
                type: "success",
                message: "导出成功!",
                duration: 1000,
              });
            }
          );
          break;

        default:
          break;
      }
    },
    /**
     * 表格中的操作事件
     */
    async handleClick(data) {
      try {
        let resultData = {};
        this.tempQuestion = JSON.parse(JSON.stringify(data.item));
        switch (data.active) {
          case "edit_exam":
            //   编辑考试
            console.log("编辑考试", data);
            this.$router.push({
              path: "/admin/exam-index/edit",
              query: {
                id: this.tempQuestion.id,
              },
            });
            break;
          case "delete_exam":
            //   删除考试
            this.$confirm("此操作将永久删除该考试, 是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(async () => {
                resultData = await this.$request({
                  url: "/exam/deleteExam",
                  method: "post",
                  data: { id: this.tempQuestion.id },
                });
                this.$message.success("发布成功!");
                await this.initTable({
                  pageData: this.pageData,
                  searchData: this.searchData,
                });
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消删除",
                });
              });
            break;
          case "issue_exam":
            // 发布考试
            resultData = await this.$request({
              url: "/exam/publishExam",
              method: "post",
              data: { id: this.tempQuestion.id },
            });
            this.$message.success("发布成功!");
            await this.initTable({
              pageData: this.pageData,
              searchData: this.searchData,
            });
            break;
          case "unissue_exam":
            // 取消发布考试
            resultData = await this.$request({
              url: "/exam/cancelPublish",
              method: "post",
              data: { id: this.tempQuestion.id },
            });
            this.$message.success("取消成功!");
            await this.initTable({
              pageData: this.pageData,
              searchData: this.searchData,
            });
            break;
          case "end_exam":
            // 考试归档
            this.$confirm(
              "考试归档后,该任务已全部结束,请确保所有学员的考试成绩已录入!",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(async () => {
                resultData = await this.$request({
                  url: "/exam/endExam",
                  method: "post",
                  data: { id: this.tempQuestion.id },
                });
                this.$message({
                  type: "success",
                  message: "考试已归档!",
                });
                await this.initTable({
                  pageData: this.pageData,
                  searchData: this.searchData,
                });
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消归档",
                });
              });
            break;
          case "start_read":
            // 结束考试(阅卷老师开始阅卷)
            this.$confirm(
              "考试结束后,当前考试将无法继续,未提交的考生视为缺考,是否继续?",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(async () => {
                resultData = await this.$request({
                  url: "/teacherExam/startRead",
                  method: "post",
                  data: { examId: this.tempQuestion.id },
                });
                this.$message({
                  type: "success",
                  message: "考试已结束,请等待阅卷老师阅卷!",
                });
                await this.initTable({
                  pageData: this.pageData,
                  searchData: this.searchData,
                });
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消",
                });
              });
            break;
          case "show_exam":
            // 查看考试详情
            this.dialogData.title = "查看考试详情";
            this.dialogData.dialogData = [
              { type: "exam_details", value: this.tempQuestion.id },
            ];
            this.dialogData.width = "50%";
            this.dialogData.buttonList = [];
            this.dialogData.flag = true;
            break;
          case "operat":
            // 查看操作记录;
            console.log("查看操作记录");
            resultData = await this.$request({
              url: "/operationRecord/getRecordList",
              method: "post",
              data: { model: "exam", modelId: this.tempQuestion.id },
            });
            this.dialogData.title = "操作记录";
            this.dialogData.dialogData = [
              { type: "operation", value: resultData },
            ];
            this.dialogData.buttonList = [];
            this.dialogData.flag = true;
            break;
          case "import":
            // 导出成绩
            this.$requestForReport(
              "post",
              "/examPlan/exportExamPlan",
              { id: this.tempQuestion.id },
              (data) => {
                let blob = new Blob([data], {
                  type: "application/force-download",
                }); // Blob 对象表示一个不可变、原始数据的类文件对象
                console.log(blob);
                let fileReader = new FileReader(); // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
                fileReader.readAsDataURL(blob);
                //开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
                fileReader.onload = (e) => {
                  let a = document.createElement("a");
                  a.download = this.tempQuestion.name + `考试成绩.xls`;
                  a.href = e.target.result;
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                };

                this.$message({
                  type: "success",
                  message: "导出成功!",
                  duration: 1000,
                });
              }
            );
            break;
          case "export_exam_plane":
            // 导出排号
            this.$requestForReport(
              "post",
              "/examPlan/exportSeat",
              { id: this.tempQuestion.id },
              (data) => {
                let blob = new Blob([data], {
                  type: "application/force-download",
                }); // Blob 对象表示一个不可变、原始数据的类文件对象
                console.log(blob);
                let fileReader = new FileReader(); // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
                fileReader.readAsDataURL(blob);
                //开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
                fileReader.onload = (e) => {
                  let a = document.createElement("a");
                  a.download = `考试计划表.xls`;
                  a.href = e.target.result;
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                };

                this.$message({
                  type: "success",
                  message: "导出成功!",
                  duration: 1000,
                });
              }
            );
            break;
          default:
            break;
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    dialogOper(active) {
      switch (active) {
        case "cancel":
          this.colseDialog();
          break;

        default:
          break;
      }
    },
    /**
     * active的监听事件
     */
    showActive(data) {
      this.active = data;
    },
    colseDialog() {
      this.dialogData.flag = false;
    },
  },
  async mounted() {
    await this.getUsersAllAuthorityByModel();
    await this.initTable({
      pageData: this.pageData,
      searchData: this.searchData,
    });
    sessionStorage.removeItem("eaxmId");
  },
};
</script>

<style lang="less" scoped>
#admin-exam-list {
  width: 100%;
  height: 100%;
}
</style>